import React from 'react';
// Components imports.
// import { useTranslation } from 'components/lib';
// MaterialUI imports.
import { Paper, Typography } from '@mui/material';
import {
    Timeline, TimelineItem, TimelineSeparator, TimelineConnector,
    TimelineContent, TimelineOppositeContent, TimelineDot
} from '@mui/lab';

// Other imports.
import { listKeyGenerator } from 'utils/helpers/listKeyGenerator';

export function TestCaseTimeline(props) {

    // const { t } = useTranslation();
    const listUUIDs = listKeyGenerator(props.attempts);

    return (
        <React.Fragment key={`li-attemptTimeline`}>
            <Timeline>
                {props.stepData.slice().reverse().map((label, index) => {
                    if (label[0].includes('Already Uncovered')) {
                        return (
                            <div id={'attempt' + index}
                                key={listUUIDs[index]}
                            >
                                {/* failed item start */}
                                < TimelineItem >
                                    <TimelineOppositeContent>
                                        {label[0]}
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                        <TimelineDot color="error" variant={index === 0 ? "filled" : "outlined"} />
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                        {/* {t('Streams.ChallengeLevelOne.ChallengeLevelOne.timeLine.uncovered')}  */}
                                        Try different data. </TimelineContent>
                                </TimelineItem>
                                {/* failed item end */}
                            </div>
                        );
                    } else {
                        return (
                            <div id={'attempt' + index}
                                key={listUUIDs[index]}
                            >
                                {/* success item start */}
                                < TimelineItem >
                                    <TimelineSeparator>
                                        <TimelineDot color="success" variant={index === 0 ? "filled" : "outlined"} />
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ textTransform: 'capitalize' }}>
                                        <Paper
                                            elevation={8}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                padding: '8px',
                                                bgcolor: label[1] === "Negative" ? "#fbe9e7" : "#e3fee1"
                                            }}>
                                            {label[0]}
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    ml: "-2px",
                                                    color: "rgba(0, 0, 0, 0.6)",
                                                }}
                                            >
                                                {label[1]} Test Case
                                                {/* {t('Streams.ChallengeLevelOne.ChallengeLevelOne.timeLine.correct')} */}
                                            </Typography>
                                        </Paper>
                                    </TimelineContent>
                                </TimelineItem >
                                {/* success item end */}
                            </div>
                        );
                    }
                })}
            </Timeline >
        </React.Fragment >
    );
}